import { ArrowClockwise, WarningCircle } from '@phosphor-icons/react';

import pt from '../../locales/pt';
import { cn } from '../../utils/cn';

/**
 * Estado de erro dos cartões da família «group-card» do `.pen`
 * (`ds/card/budget-group` › `error`, e espelhos em `expense-group--fechado`,
 * `expense-group--aberto`, `record-day-group`, `composition-group`).
 *
 * Estrutura/tokens vindos do `.pen`:
 *   frame vertical · gap `$space-3` · padding `$space-5` · center/center
 *     err-chip  40×40 · `$warning-tint` · `$radius-ds-full` · stroke `$border`
 *       icon    20 · warning-circle · `$warning-fg`
 *     err-t     `$type-body` 600 · `$fg-card` · centrado
 *     err-action gap `$space-1`
 *       texto   `$type-body-sm` 600 · `$sage-on-tint`
 *       icon    14 · arrow-clockwise · `$sage-on-tint`
 *
 * Tom `warning` (não `danger`) — decisão de desenho fechada no `.pen`.
 *
 * `title`/`message` são aliases do mesmo texto — mantidos os dois nomes
 * porque consumidores das famílias `group-card` e `hero` chamam a prop de
 * forma diferente.
 */
export function CardErrorState({ title, message, onRetry, className, ...rest }) {
  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center gap-space-3 p-space-5',
        className,
      )}
      role="alert"
      {...rest}
    >
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-ds-full border border-border bg-warning-tint">
        <WarningCircle className="h-5 w-5 text-warning-fg" aria-hidden />
      </span>
      <p className="type-body w-full text-center font-semibold text-card-foreground">
        {title ?? message}
      </p>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="type-body-sm flex items-center gap-space-1 font-semibold text-sage-on-tint hover:underline"
        >
          {pt.common.tryAgain}
          <ArrowClockwise className="h-3.5 w-3.5" aria-hidden />
        </button>
      ) : null}
    </div>
  );
}

/**
 * Classe utilitária para quando `CardErrorState` é composto DENTRO de um
 * wrapper que já traz o chrome do cartão (`rounded-ds-lg border bg-card
 * p-space-5` etc. — famílias `hero`). Cancela o padding do wrapper via
 * `tailwind-merge` (última classe ganha) para não duplicar com o
 * `p-space-5` que o próprio `CardErrorState` já aplica.
 */
export const ERROR_BOX_CLASS = 'items-center justify-center p-0';
